module.exports = __webpack_public_path__ + "img/area-part4-221.146102b9.png";